import { useState, useCallback } from 'react';

/**
 * 출발지/도착지 동일 토글 로직을 캡슐화합니다.
 * @param {string} departure - 현재 출발지 값
 * @param {Function} setDestination - 도착지 setter
 * @param {object} [opts] - #216: 표시 명칭 동기화용. 체크 시 도착지를 출발지로 미러하면서
 *   name/nameI18n 까지 함께 세팅해야 영문 환경에서 한글 raw 주소로 회귀하지 않음.
 *   해제 시에는 미러였던 값을 비워 사용자가 새 도착지를 고르게 한다.
 */
export function useSameDepartureArrival(departure, setDestination, opts = {}) {
  const { departureName = '', departureNameI18n = '', setDestinationName, setDestinationNameI18n } = opts;
  const [sameAsDeparture, setSameAsDeparture] = useState(false);

  const handleSameAsDeparture = useCallback(() => {
    setSameAsDeparture((prev) => {
      if (!prev) {
        setDestination(departure);
        setDestinationName?.(departureName);
        setDestinationNameI18n?.(departureNameI18n || departureName);
      } else {
        setDestination('');
        setDestinationName?.('');
        setDestinationNameI18n?.('');
      }
      return !prev;
    });
  }, [departure, departureName, departureNameI18n, setDestination, setDestinationName, setDestinationNameI18n]);

  return { sameAsDeparture, setSameAsDeparture, handleSameAsDeparture };
}
